<template>
  <main id="main">
    <SponsorListForm/>
  </main>
</template>
<script>
import SponsorListForm from '@/components/sponsor/SponsorListForm.vue';

export default {
  components: {
    SponsorListForm
  }
}
</script>
<style>
    
</style>